import Footer from './components/footer';
import Header from './components/header';
import Home from './containers/Home';

function App() {
  return (
    <div className="App">
        <Header />
        <Home />
        <Footer />
    </div>
  );
}

export default App;
